import { useEffect, useState } from "react";
import throttle from "lodash.throttle";
import { EVENT_HANDLER_THROTTLE_TIME } from "../../Consts";

/**
 * Custom React hook that tracks the current window scroll position (Y-axis).
 * 
 * Uses lodash.throttle to optimize performance by limiting scroll event handler frequency.
 * 
 * @returns The latest scrollY position of the window.
 */
export const useWindowScroll = (): number => {
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = throttle(() => {
            setScrollY(window.scrollY);
        }, EVENT_HANDLER_THROTTLE_TIME);

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return scrollY;
};
